<template>
    <div id="gh-vite-app-root">
        <slot />
    </div>
</template>

<script setup lang="ts"></script>
